import { ReportChartCompare, ReportChartFilter, ReportsDetailGraphicSchemaValues } from '@vision/ui/interfaces';
import { EMPTY_TICKET_REPORTING_FILTERS } from '../../../utils/reports/ticket-reporting-filter.util';
import { DEFAULT_REPORT_DATE_PICKER_VALUE } from './default-chart.config';

export const DEFAULT_REPORT_DETAIL_GRAPHIC_FILTER_SCHEMA_VALUES: ReportChartFilter = {
  ...EMPTY_TICKET_REPORTING_FILTERS,
  selectedChannelIds: [],
  selectedChannelTypes: [],
  selectedAssignedUserIds: [],
  selectedFeedbackStatus: [],
  selectedFlowIds: [],
  selectedIntelligentTagIds: [],
  selectedLanguageIds: [],
  selectedQuestionIds: [],
  selectedQuestionOptionIds: [],
  selectedTagGroupIds: [],
  selectedTagIds: [],
  selectedUnitTypeIds: [],
  selectedUnitIds: [],
  hasComments: null,
  hasContactInfo: null,
  spamFeedback: null,
  onlyNegativeFeedback: null,
  includeIncompleteFeedback: false,
  selectedContentCategoryIds: [],
  selectedContentCategoryAiModelId: null,
  selectedEmployeeStageTitles: [],
  selectedDepartmentIds: [],
  selectedAiModelIds: [],
  selectedMeasureValue: null,
  selectedAtaSentiment: null,
  selectedCustomerSchemaIds: [],
  selectedCustomerSchemaValues: [],
};

export const DEFAULT_REPORT_DETAIL_GRAPHIC_COMPARE_SCHEMA_VALUES: ReportChartCompare = {
  selectedChannelIds: [],
  selectedChannelTypes: [],
  selectedCompanyIds: [],
  selectedFlowIds: [],
  selectedIntelligentTagIds: [],
  selectedQuestionFlowIds: [],
  selectedQuestionIds: [],
  selectedMatrixQuestionStatementIds: [],
  selectedQuestionOptionFlowIds: [],
  selectedQuestionOptionQuestionIds: [],
  selectedQuestionOptionIds: [],
  selectedQuestionResponseFlowIds: [],
  selectedQuestionResponseQuestionIds: [],
  selectedQuestionKeyFlowIds: [],
  selectedQuestionKeyIds: [],
  selectedQuestionCategoryFlowIds: [],
  selectedQuestionCategoryIds: [],
  selectedQuestionOptionScoreFlowIds: [],
  selectedQuestionOptionScoreQuestionIds: [],
  selectedQuestionOptionScoreStyle: null,
  selectedSchemaCodes: [],
  selectedSchemaTagIds: [],
  selectedTagGroupIds: [],
  selectedTagTagGroupIds: [],
  selectedTagGroupNameIds: [],
  selectedUnitIds: [],
  selectedUnitTypeIds: [],
  selectedUserIds: [],
  selectedUserAssignedIds: [],
  selectedUserArchivingIds: [],
  selectedUserResponsibleIds: [],
  selectedContentCategoryIds: [],
  selectedContentCategoryAiModelId: null,
  selectedFeedbackStatus: [],
};

export const DEFAULT_REPORT_DETAIL_GRAPHIC_SCHEMA_VALUES: ReportsDetailGraphicSchemaValues = {
  selectedDate: DEFAULT_REPORT_DATE_PICKER_VALUE,
  selectedComparisonDate: null,
  selectedTheme: {},
  selectedCustomize: {},
  selectedFilterKeys: [],
  selectedFilters: {
    ...DEFAULT_REPORT_DETAIL_GRAPHIC_FILTER_SCHEMA_VALUES,
  },
  selectedMeasure: null,
  selectedMetricStatusIds: [],
  selectedMultipleMeasure: [],
  selectedCompare: [],
  selectedCompareCriteria: {
    ...DEFAULT_REPORT_DETAIL_GRAPHIC_COMPARE_SCHEMA_VALUES,
  },
  selectedPeriodAndValueComparison: [],
  applyContext: false,
  weightContext: {},
  selectedFeedbackBasedQuestionBased: null,
  selectedCompareQuestionIds: [],
  selectedCompareQuestionStatementIds: [],
  selectedCompareFlowIds: [],
  selectedTableDispatch: {
    channelId: null,
    channelType: null,
    flowId: null,
    schemaSelections: [],
  },
};
